import { useState, useEffect } from 'react';
import { masterDataService } from '../services/masterData/masterDataService';
import { Plant, Building, Floor, Location, Department, Category, Subcategory, PriorityMaster, StatusMaster } from '../types/masterData';

export const useMasterData = () => {
  const [plants, setPlants] = useState<Plant[]>([]);
  const [departments, setDepartments] = useState<Department[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [priorities, setPriorities] = useState<PriorityMaster[]>([]);
  const [statuses, setStatuses] = useState<StatusMaster[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchMasters = async () => {
      setIsLoading(true);
      try {
        const [plantsRes, deptsRes, catsRes, prioRes, statRes] = await Promise.all([
          masterDataService.getPlants(),
          masterDataService.getDepartments(),
          masterDataService.getCategories(),
          masterDataService.getPriorities(),
          masterDataService.getStatuses(),
        ]);

        if (plantsRes.success) setPlants(plantsRes.data);
        if (deptsRes.success) setDepartments(deptsRes.data);
        if (catsRes.success) setCategories(catsRes.data);
        if (prioRes.success) setPriorities(prioRes.data);
        if (statRes.success) setStatuses(statRes.data);
      } catch (e) {
        console.error(e);
      }
      setIsLoading(false);
    };

    fetchMasters();
  }, []);

  return {
    plants,
    departments,
    categories,
    priorities,
    statuses,
    isLoading,
  };
};

export const useLocationCascade = (selectedPlantId?: string, selectedBuildingId?: string, selectedFloorId?: string) => {
  const [buildings, setBuildings] = useState<Building[]>([]);
  const [floors, setFloors] = useState<Floor[]>([]);
  const [locations, setLocations] = useState<Location[]>([]);

  useEffect(() => {
    if (selectedPlantId) {
      masterDataService.getBuildings(selectedPlantId).then(res => {
        if (res.success) setBuildings(res.data);
      });
    } else {
      setBuildings([]);
    }
  }, [selectedPlantId]);

  useEffect(() => {
    if (selectedBuildingId) {
      masterDataService.getFloors(selectedBuildingId).then(res => {
        if (res.success) setFloors(res.data);
      });
    } else {
      setFloors([]);
    }
  }, [selectedBuildingId]);

  useEffect(() => {
    if (selectedFloorId) {
      masterDataService.getLocations(selectedFloorId).then(res => {
        if (res.success) setLocations(res.data);
      });
    } else {
      setLocations([]);
    }
  }, [selectedFloorId]);

  return { buildings, floors, locations };
};
